<div class="filter">
  <div class="filter__header" (click)="isFilterExpanded = !isFilterExpanded">
    <div class="filter__header__title">
      <i class="angularjs-fuse-icon icon-filter"></i>
      {{ 'FILTER.TITLE' | translate }}
    </div>

    <div class="filter__header__expand">
      <span *ngIf="isFilterExpanded">{{ 'FILTER.COLLAPSE' | translate }}</span>
      <span *ngIf="!isFilterExpanded">{{ 'FILTER.EXPAND' | translate }}</span>
    </div>
  </div>
  <div *ngIf="isFilterExpanded" class="filter__content">
    <div class="filter__content__date">
      <div class="filter__content__date__title">
        {{ 'FILTER.FILTER_BY.OPENED_AT' | translate }}
      </div>
      <fc-date-input
        [control]="filtersForm.get('openedAtGte')"
        [max]="filtersForm.get('openedAtLte').value"
        [placeholder]="'FILTER.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="FILTER.ERRORS"
      ></fc-date-input>
      <div class="filter__content__date__text">
        {{ 'FILTER.TO' | translate }}
      </div>
      <fc-date-input
        [control]="filtersForm.get('openedAtLte')"
        [min]="filtersForm.get('openedAtGte').value"
        [placeholder]="'FILTER.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="FILTER.ERRORS"
      ></fc-date-input>
    </div>

    <div class="filter__content__date">
      <div class="filter__content__date__title">
        {{ 'FILTER.FILTER_BY.SCHEDULED_AT' | translate }}
      </div>
      <fc-date-input
        [control]="filtersForm.get('scheduledAtGte')"
        [max]="filtersForm.get('scheduledAtLte').value"
        [placeholder]="'FILTER.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="FILTER.ERRORS"
      ></fc-date-input>
      <div class="filter__content__date__text">
        {{ 'FILTER.TO' | translate }}
      </div>
      <fc-date-input
        [control]="filtersForm.get('scheduledAtLte')"
        [min]="filtersForm.get('scheduledAtGte').value"
        [placeholder]="'FILTER.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="FILTER.ERRORS"
      ></fc-date-input>
    </div>

    <div class="filter__content__date">
      <div class="filter__content__date__title">
        {{ 'FILTER.FILTER_BY.CLOSED_AT' | translate }}
      </div>
      <fc-date-input
        [control]="filtersForm.get('closedAtGte')"
        [max]="filtersForm.get('closedAtLte').value"
        [placeholder]="'FILTER.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="FILTER.ERRORS"
      ></fc-date-input>
      <div class="filter__content__date__text">
        {{ 'FILTER.TO' | translate }}
      </div>
      <fc-date-input
        [control]="filtersForm.get('closedAtLte')"
        [min]="filtersForm.get('closedAtGte').value"
        [placeholder]="'FILTER.DATE_PLACEHOLDER' | translate"
        translateErrorPrefix="FILTER.ERRORS"
      ></fc-date-input>
    </div>

    <fc-locations-input [control]="filtersForm.get('locations')" [showSearchIcon]="true"></fc-locations-input>
    <fc-maintenance-types-input [control]="filtersForm.get('maintenanceTypes')"></fc-maintenance-types-input>
    <fc-companies-input [control]="filtersForm.get('companies')"></fc-companies-input>
    <fc-location-groups-input [control]="filtersForm.get('locationGroups')"></fc-location-groups-input>
    <fc-segments-input [control]="filtersForm.get('segments')"></fc-segments-input>
  </div>
</div>
